module.exports = __webpack_public_path__ + "static/media/Olivia Main Wardrobe (5).101ba342.jpg";